export default "__VITE_ASSET__DpGV8Jcu__"